import * as $ from 'jquery';
import 'jvectormap';
import 'jvectormap/jquery-jvectormap.css';
import '../vectorMaps/jquery-jvectormap-world-mill.js';
import { debounce } from 'lodash';

export default (function () {
    const vectorMapInit = () => {
        if ($('#orders-per-website-map').length > 0) {
            // This is a hack, as the .empty() did not do the work
            $('#vmap-orders-per-website-map').remove();

            // we recreate (after removing it) the container div, to reset all the data of the map
            $('#orders-per-website-map').append(`
        <div
          id="vmap-orders-per-website-map"
          style="
            height: 490px;
            position: relative;
            overflow: hidden;
            background-color: transparent;
          "
        >
        </div>
      `);
            var data = $('#orders-per-website-map').data('json');
            $('#vmap-orders-per-website-map').vectorMap({
                map: 'world_mill',
                backgroundColor: '#fff',
                borderColor: '#fff',
                borderOpacity: 0.25,
                borderWidth: 0,
                color: '#e6e6e6',
                regionStyle : {
                    initial : {
                        fill : '#e4ecef',
                    },
                },
                series: {
                    regions: [{
                        values: data,
                        scale: ['#38c1ff', '#0072a5'],
                        normalizeFunction: 'polynomial',
                    }],
                },
                onRegionTipShow: function(e, el, code){
                    var html = el.html(),
                        value = data[code];
                    if(value)
                        html += ' (&euro;'+Math.round(data[code])+')';

                    el.html(html);
                },

                scaleColors: ['#000000', '#ffffff'],
                selectedColor: '#c9dfaf',
                selectedRegions: [],
                hoverColor: '#fff',
            });
        }
    };

    vectorMapInit();
    // $(window).resize(debounce(vectorMapInit, 150));
})();
